module.exports = __webpack_public_path__ + "img/golden.2b58a1d5.svg";